import { Controller } from "@hotwired/stimulus"

// Toggles a menu and closes it on an outside click. Used by the admin header
// user block.
export default class extends Controller {
  static targets = ["menu"]

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle("hidden")
  }

  hide() {
    this.menuTarget.classList.add("hidden")
  }

  connect() {
    this._close = (e) => { if (!this.element.contains(e.target)) this.hide() }
    document.addEventListener("click", this._close)
  }

  disconnect() {
    document.removeEventListener("click", this._close)
  }
}
